export default __webpack_public_path__ + "static/media/delighted.bb7bfcc3.svg";